import { Link } from "react-router-dom";
import { Facebook, Youtube, Music2, Podcast } from "lucide-react";
import { NAV } from "./Header";
import { Flourish } from "@/components/Common";

export const Footer = () => (
  <footer className="bg-[#1a0d05] text-[#e8dfcc] mt-16">
    <div className="max-w-7xl mx-auto px-4 py-10">
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm sm:text-base" data-testid="footer-nav">
        {NAV.map((n, i) => (
          <span key={n.to} className="flex items-center gap-4">
            <Link to={n.to} data-testid={`footer-link-${i}`} className="hover:text-[#d4af37] transition-colors leading-[2]">{n.label}</Link>
            {i < NAV.length - 1 && <span className="text-[#d4af37]/40">|</span>}
          </span>
        ))}
      </div>

      <div className="flex items-center justify-center gap-4 mt-8">
        {[
          { Icon: Facebook, id: "social-facebook", href: "https://www.facebook.com" },
          { Icon: Youtube, id: "social-youtube", href: "https://www.youtube.com/channel/UCrojXw0U5-rrBg8nqiltUvQ" },
          { Icon: Music2, id: "social-spotify", href: "https://www.spotify.com" },
          { Icon: Podcast, id: "social-podcast", href: "https://www.rekhta.org/podcasts" },
        ].map(({ Icon, id, href }) => (
          <a
            key={id}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={id}
            className="w-10 h-10 rounded-full border border-[#d4af37]/40 flex items-center justify-center text-[#d4af37] hover:bg-[#d4af37] hover:text-[#1a0d05] transition-colors"
          >
            <Icon size={16} />
          </a>
        ))}
      </div>

      <Flourish className="w-48 mx-auto mt-8 text-[#c5a059]/60" />

      <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-6 pt-6 border-t border-[#d4af37]/20 text-sm text-[#c5a059]">
        <span className="font-latin tracking-wide" data-testid="footer-copyright">© 2025 AdabNama. All Rights Reserved.</span>
        <Link to="/about" data-testid="footer-about-link" className="text-[#e8dfcc] hover:text-[#d4af37] transition-colors leading-[2] underline decoration-[#c5a059]/50 underline-offset-4">ادب نامہ کے بارے میں</Link>
        <span className="leading-[2]">اردو زبان زندہ باد — ادب زندہ باد</span>
      </div>
    </div>
  </footer>
);
